import type { ApiAppParams } from 'typings/apiApp';

export enum AppEvents {
  TOGGLE_TOOLTIP = 'app/toggleTooltip',
  TOGGLE_CART = 'app/toggleCart',
  TOGGLE_CHAT = 'app/toggleChat',
  RESET_CONFIG = 'app/resetConfig',
  UPDATE_PARAMS = 'app/updateParams',
  UPDATE_SESSION = 'app/updateSession',
  SEND_NEW_MESSAGE = 'app/sendNewMessage',
  UPDATE_PRODUCT_LIST = 'app/updateProductList',
  GET_SUGGESTION = 'app/getSuggestion',
  SHOW_CROSS_SALE = 'app/showCrossSale',
  RESET_CHAT = 'app/resetChat',
}

export const toggleTooltip = (isOpenTooltip: boolean) => {
  const event = new CustomEvent(AppEvents.TOGGLE_TOOLTIP, {
    detail: isOpenTooltip,
  });

  window.dispatchEvent(event);
};

export const toggleAppChat = (isNewChat?: boolean) => {
  const event = new CustomEvent(AppEvents.TOGGLE_CHAT, {
    detail: isNewChat,
  });

  window.dispatchEvent(event);
};

export const updateAppParams = (params?: Partial<ApiAppParams>) => {
  const event = new CustomEvent(AppEvents.UPDATE_PARAMS, {
    detail: params,
  });

  window.dispatchEvent(event);
};

export const toggleCart = (isOpenCart?: boolean) => {
  const event = new CustomEvent(AppEvents.TOGGLE_CART, {
    detail: isOpenCart,
  });

  window.dispatchEvent(event);
};

export const updateProductList = () => {
  const event = new CustomEvent(AppEvents.UPDATE_PRODUCT_LIST);

  window.dispatchEvent(event);
};

export const sendNewMessage = (messageText: string, selectedOptions?: string[]) => {
  const event = new CustomEvent(AppEvents.SEND_NEW_MESSAGE, {
    detail: {
      messageText,
      selectedOptions,
    },
  });
  window.dispatchEvent(event);
};

export const updateSession = () => {
  const event = new CustomEvent(AppEvents.UPDATE_SESSION);
  window.dispatchEvent(event);
};

export const resetConfig = () => {
  const event = new CustomEvent(AppEvents.RESET_CONFIG);
  window.dispatchEvent(event);
};

export const resetChat = () => {
  const event = new CustomEvent(AppEvents.RESET_CHAT);
  window.dispatchEvent(event);
};

export const getSuggestion = (productsList: string[]) => {
  const event = new CustomEvent(AppEvents.GET_SUGGESTION, {
    detail: {
      productsList,
    },
  });
  window.dispatchEvent(event);
};

export const showCrossSale = () => {
  const event = new CustomEvent(AppEvents.SHOW_CROSS_SALE);
  window.dispatchEvent(event);
};
